const jobList = [
  {
    'company': 'Coolblue',
    'from': '2021-01-01',
    'to': null,
    'rol': 'Senior Software engineer',
    'img': 'coolblue.png',
    'companyUrl': 'https://www.coolblue.nl/'
  },
  {
    'company': 'T comm telematics',
    'from': '2019-12-01',
    'to': '2020-12-30',
    'rol': 'Software engineer',
    'img': 'tcomm.png',
    'companyUrl': 'https://www.tcommtelematics.com/'
  },
  {
    'company': 'Digital Insurance Group',
    'from': '2018-02-01',
    'to': '2019-12-01',
    'rol': 'PHP Backend developer',
    'img': 'dig.png',
    'companyUrl': 'https://digitalinsurance.io/'
  },
  {
    'company': 'WddingWire, bodas.net',
    'from': '2017-05-01',
    'to': '2018-01-20',
    'rol': 'PHP Backend developer',
    'img': 'bodasnet.png',
    'companyUrl': 'https://www.weddingwire.com/'
  },
  {
    'company': 'Transmural Biotech and Fetal Medicine Barcelona',
    'from': '2013-03-01',
    'to': '2017-05-01',
    'rol': 'Head of IT and Web department',
    'img': 'groupOfCompanies.png',
    'companyUrl': 'https://fetalmedbarcelona.org/en/research'
  },
  {
    'company': 'IBM',
    'from': '2011-10-01',
    'to': '2013-02-01',
    'rol': 'Remote support',
    'img': 'ibm.png',
    'companyUrl': null
  }
];

const studyList = [
  {
    'study': "Software engineering (online)",
    'center': "Universitat Oberta de Catalunya",
    'from': "2016",
    'to': "2022",
  },
  {
    'study': "Software engineering",
    'center': "Polytechnic University of Catalonia",
    'from': "2013",
    'to': "2015",
  },
  {
    'study': "Certificate of Higher Education in Telecommunications and computing",
    'center': "Anna Gironella de Mundet",
    'from': "2011",
    'to': "2013",
  },
  {
    'study': "Vocational Education and Training in Computing and network",
    'center': "IES Ferreria",
    'from': "2009",
    'to': "2011",
  }
];

module.exports = { jobList, studyList }